import type AudacyError from '@audacy-clients/client-services/src/AudacyError';
import { Helmet } from 'react-helmet-async';

import ErrorWithRetry from '~/components/Error/';
import PageNotFound from '~/components/Error/404';
import { Mixins } from '~/styles';

interface IErrorScreenProps {
  error?: Error | AudacyError;
}

const FullScreenError = ({ error }: IErrorScreenProps): JSX.Element => {
  const is404 =
    !!error &&
    (('audacyErrorJson' in error && error?.audacyErrorJson?.code === 404) ||
      (typeof error.message === 'string' && error.message.includes('status: 404')));
  return (
    <div css={Mixins.fullScreenContainer}>
      {!is404 && (
        <Helmet>
          <script>{'window.prerenderReady = true;'}</script>
        </Helmet>
      )}
      {is404 ? <PageNotFound /> : <ErrorWithRetry />}
    </div>
  );
};

export default FullScreenError;
